import Vue from 'vue';
import Vuex from 'vuex';

import {Store} from '@/enums/Store';

import VuexPersistence from 'vuex-persist';
const storeKey = window.location.pathname;
const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  key: storeKey
});

import app from './app';
import event from './event';
import member from './member';
import location from './location'
import invoiceRecipient from './invoiceRecipient'
import customer from './customer'
import cart from './cart'
import paymentInterval from './paymentInterval'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    [Store.APP]: app,
    [Store.EVENT]: event,
    [Store.MEMBER]: member,
    [Store.LOCATION]: location,
    [Store.INVOICE_RECIPIENT]: invoiceRecipient,
    [Store.CUSTOMER]: customer,
    [Store.CART]: cart,
    [Store.PAYMENT_INTERVAL]: paymentInterval
  },
  plugins: [vuexLocal.plugin]
});
